/**
 * Homepage headline alternate content experiment:
 * https:www.notion.so/faire/Low-lift-testing-Batch-2-cfd95df3dffe4210a9cf9ef8e68c6da4
 */
export const HOMEPAGE_HEADLINE_OPTIONS_240826 = 'HOMEPAGE_HEADLINE_OPTIONS_240826';
